module.exports = __webpack_public_path__ + "static/media/btn-play-white.7e4c5ba4.svg";